import store from '~/redux/store'
import { addProcessFctImgs } from '~/redux/actions/actions'

export default data => {
  store.dispatch(addProcessFctImgs({ data }))
}
